import script from "./UploadFileItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadFileItem.vue?vue&type=script&setup=true&lang=ts"

import "./UploadFileItem.vue?vue&type=style&index=0&id=2da961f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da961f6"]])

export default __exports__